import { render, staticRenderFns } from "./CancelDisposal.vue?vue&type=template&id=16ba12eb"
import script from "./CancelDisposal.vue?vue&type=script&lang=js"
export * from "./CancelDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports